export default __webpack_public_path__ + "static/media/location.34ed94f2.png";